import safeStorage from '@github-ui/safe-storage'
import type {PlaygroundMessage} from './model-client'

export type StoredChatMessages = {
  modelName: string
  messages: PlaygroundMessage[]
}

const safeLocalStorage = safeStorage('localStorage', {
  ttl: 1000 * 60 * 60 * 24,
  throwQuotaErrorsOnSet: false,
})

export function getSavedPlaygroundMessages() {
  const savedMessages = safeLocalStorage.getItem('playground-chat-messages')
  return savedMessages
    ? JSON.parse(savedMessages, (key, value) => {
        if (key === 'timestamp') {
          return new Date(value)
        } else {
          return value
        }
      })
    : null
}

export function setPlaygroundMessages(chatMessages: StoredChatMessages) {
  const value = JSON.stringify(chatMessages)
  safeLocalStorage.setItem('playground-chat-messages', value)
}

export function clearPlaygroundLocalStorage() {
  safeLocalStorage.removeItem('playground-chat-messages')
}

export class PlaygroundLocalStorage {
  marketplaceModelsPreferredLanguageKey = 'marketplaceModelsPreferredLanguage'

  get preferredLanguage(): string | null {
    return safeLocalStorage.getItem(this.marketplaceModelsPreferredLanguageKey)
  }

  set preferredLanguage(inputType: string) {
    safeLocalStorage.setItem(this.marketplaceModelsPreferredLanguageKey, inputType)
  }
}
